import ImporterLoader from './importer-loader';

export default ImporterLoader;
